import React from 'react';
import PropTypes from 'prop-types';

export default class LeadListEntry extends React.Component {
  static propTypes = {
    lead: PropTypes.shape({
      id: PropTypes.number.isRequired,
      projectId: PropTypes.number.isRequired,
      projectName: PropTypes.string.isRequired,
      source: PropTypes.string.isRequired,
      statusLabel: PropTypes.string,
      user: PropTypes.shape({
        name: PropTypes.string.isRequired
      }).isRequired
    })
  };

  render() {
    const { lead } = this.props;

    return (
      <tr>
        <td>
          <a href={`/projects/${lead.projectId}?tab=leads`} name="lead-project-link">
            {lead.projectName}
          </a>
        </td>
        <td name="lead-status">{lead.statusLabel}</td>
        <td name="lead-source">{this.renderSource()}</td>
        <td name="lead-actions">{/* Actions */}</td>
      </tr>
    );
  }



  renderSource() {
    const { source, user } = this.props.lead;

    switch (source) {
    case 'web_activity':
      return 'Web Activity';
    case 'imported':
      return `Import (${user.name})`;
    default:
      return user.name;
    }
  }
}
